import React from "react";
import { Stack, Typography } from "@mui/material";

/**
 * One key/value line on a card: grey label left, value right-aligned in a
 * monospace face, hairline above. Pass ``children`` instead of ``value`` to
 * render something other than text on the right (e.g. a colour chip).
 *
 * @param dense  tighter vertical padding (used in the exploration picker)
 */
export default function FactRow({ label, value, title, children, dense = false }) {
    return (
        <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            sx={{ py: dense ? 0.55 : 1, borderTop: "1px solid", borderColor: "rgba(15, 23, 42, 0.06)", minWidth: 0 }}
        >
            <Typography variant="body2" sx={{ color: "text.secondary", flexShrink: 0, fontSize: dense ? "0.78rem" : undefined }}>
                {label}
            </Typography>
            {children || (
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 500,
                        color: "text.primary",
                        textAlign: "right",
                        wordBreak: "break-word",
                        fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
                        fontSize: dense ? "0.76rem" : "0.8rem",
                    }}
                    title={title || value}
                >
                    {value}
                </Typography>
            )}
        </Stack>
    );
}
